/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_PipesInputs */

const en_svtag_pipes = /** @type {(inputs: Svtag_PipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PIPES`)
};

const ar_svtag_pipes = /** @type {(inputs: Svtag_PipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#أنابيب`)
};

const bn_svtag_pipes = /** @type {(inputs: Svtag_PipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PIPES`)
};

const de_svtag_pipes = /** @type {(inputs: Svtag_PipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PIPES`)
};

const es_svtag_pipes = /** @type {(inputs: Svtag_PipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PIPES`)
};

const fr_svtag_pipes = /** @type {(inputs: Svtag_PipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PIPES`)
};

const pt_svtag_pipes = /** @type {(inputs: Svtag_PipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PIPES`)
};

const zh_svtag_pipes = /** @type {(inputs: Svtag_PipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PIPES`)
};

const tr_svtag_pipes = /** @type {(inputs: Svtag_PipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PIPES`)
};

const ru_svtag_pipes = /** @type {(inputs: Svtag_PipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PIPES`)
};

const pl_svtag_pipes = /** @type {(inputs: Svtag_PipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PIPES`)
};

/**
* | output |
* | --- |
* | "#PIPES" |
*
* @param {Svtag_PipesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_pipes = /** @type {((inputs?: Svtag_PipesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_PipesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_pipes(inputs)
	if (locale === "bn") return bn_svtag_pipes(inputs)
	if (locale === "de") return de_svtag_pipes(inputs)
	if (locale === "es") return es_svtag_pipes(inputs)
	if (locale === "fr") return fr_svtag_pipes(inputs)
	if (locale === "pt") return pt_svtag_pipes(inputs)
	if (locale === "zh") return zh_svtag_pipes(inputs)
	if (locale === "tr") return tr_svtag_pipes(inputs)
	if (locale === "ru") return ru_svtag_pipes(inputs)
	if (locale === "pl") return pl_svtag_pipes(inputs)
	return en_svtag_pipes(inputs)
});